import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Style from "./Rating.module.scss";
import clsx from "clsx";
import { LoyaltyInfoView } from "./LoyaltyInfoView";
import { MyActivityView } from "./MyActivityView";

enum Panels {
  Activity = "activity",
  info = "info",
}

const RatingPage: React.FC = () => {
  const [selectedPanel, setSelectedPanel] = useState<Panels>(Panels.Activity);

  useEffect(() => {
    document.title = "Loyalty" + " | " + process.env.SITE_NAME;
  });

  const rating = useSelector((state: any) => state.UserRating?.data);

  return (
    <div className="cabinet__layout">
      <h1 className="cabinet__title">Баллы и рейтинг</h1>
      <div className="cabinet__layout-body">
        <div className={Style.rating}>
          <div className={Style.rating__header}>
            <button
              className={clsx(
                Style.rating__headerButton,
                selectedPanel === Panels.Activity &&
                  Style.rating__headerButtonActive
              )}
              onClick={() => setSelectedPanel(Panels.Activity)}
            >
              Моя активность на выставке
            </button>
            <button
              className={clsx(
                Style.rating__headerButton,
                selectedPanel === Panels.info &&
                  Style.rating__headerButtonActive
              )}
              onClick={() => setSelectedPanel(Panels.info)}
            >
              О Loyalty
            </button>
          </div>
          <div className={Style.rating__wrapper}>
            {selectedPanel === Panels.Activity && (
              <MyActivityView detailedRating={rating?.detailedRating} />
            )}
            {selectedPanel === Panels.info && <LoyaltyInfoView />}
          </div>
        </div>

        <div className="cabinet__layout-col">
          <div className={`${Style.loyalty} cabinet__block`}>
            <div className={Style.loyaltyLogo}>
              <img
                src={require("@public/images/loyalty-bg.svg")}
                alt="Loyalty"
              />
            </div>
            <div className={Style.loyaltyList}>
              <div className={Style.loyaltyItem}>
                <div className={Style.loyaltyItemTitle}>
                  Ваши баллы в сезоне:
                </div>
                <div className={Style.loyaltyItemScore}>
                  {rating?.thisYearRating}
                </div>
              </div>
              <div className={Style.loyaltyItem}>
                <div className={Style.loyaltyItemTitle}>Ваши баллы:</div>
                <div className={Style.loyaltyItemScore}>
                  {rating?.totalRating}
                </div>
              </div>
            </div>
            <a
              className="btn btn--medium btn--red"
              href="https://profi.travel/loyalty"
              target="_blank"
            >
              Правила Loyalty
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RatingPage;
